export default process.env.back_url; // eslint-disable-line no-undef
